module.exports = __webpack_public_path__ + "assets/repeat.2aca8d42.svg";